<script lang="ts" setup>
const hotelStore = useHotelStore();
const userStrore = useUserStore();
import Swal from "sweetalert2";

const checkin = ref(new Date());
const checkout = ref();
const duration = ref(1);
const room = ref(1);
const adt = ref(1);
const chd = ref(0);
const key = ref('');
const hotels = ref<any>({});
const selectedCity = ref<any>({});
const selectedHotel = ref<any>({});
const loading = ref(false);
const cariInput = ref();

const formatDate = (date: string | number | Date) => {
  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };

  const formattedDateTime = new Date(date).toLocaleString('id-ID', options);
  return formattedDateTime;
}

const selectCity = (data: any) => {
  selectedCity.value = data;
  selectedHotel.value = null;
}

const selectHotel = (data: any) => {
  selectedHotel.value = data;
  selectedCity.value = null;
}

const focusSearch = () => {
  nextTick(() => {
    let element = null;
    element = cariInput.value;
    
    if (element) {
      setTimeout(() => {
        element.focus();
      }, 100); // Adjust the delay if necessary
    } else {
      console.error(`Element with ref ${element} not found`);
    }
  });
};

onMounted(() => {
  selectedCity.value = null;
  selectedHotel.value = null;
  const newCheckout = new Date(checkin.value.getTime() + duration.value * 24 * 60 * 60 * 1000);
  checkout.value = newCheckout.toISOString().substr(0, 10);
  const newCheckin = new Date().toISOString().substr(0, 10);
  checkin.value = newCheckin;
})

const getHotel = async () => {
  if(selectedCity.value){
    try{
      loading.value = true;
      const response: any = await hotelStore.searchByCity({
        id: selectedCity.value.id,
        checkin: checkin.value,
        checkout: checkout.value,
        room: room.value,
        adt: adt.value,
        chd: chd.value,
      })
      if(response?.status.code == 200){
        localStorage.setItem('hotels',JSON.stringify(response));
        const params = {
          selected_id: selectedCity.value.id,
          checkin: checkin.value,
          checkout: checkout.value,
          room: room.value,
          adt: adt.value,
          chd: chd.value,
        }
        localStorage.setItem('hotelParam',JSON.stringify(params));
        navigateTo('/hotels/search')
      }else{
        Swal.fire({
          title: 'Failed',
          html: `${response.status.message}`,
          icon: 'warning',
        });
      }
      
    }catch(error){
      console.error(error)
    }finally{
      loading.value = false;
    }
  }else if(selectedHotel.value){
    try{
      loading.value = true;
      const response: any = await hotelStore.detailHotel({
        selected_id: selectedHotel.value.code,
        checkin: checkin.value,
        checkout: checkout.value,
        room: room.value,
        adt: adt.value,
        chd: chd.value,
      })

      if(response?.status.code == 200){
        const params = {
          checkin: checkin.value,
          checkout: checkout.value,
          room: room.value,
          adt: adt.value,
          chd: chd.value,
        }
        localStorage.setItem('hotelParam',JSON.stringify(params));
        navigateTo(`/hotels/detail?hotel=${selectedHotel.value.code}`)
      }else{
        Swal.fire({
          title: 'Failed',
          html: `${response.status.message}`,
          icon: 'warning',
        });
      }
    }catch(error){
      console.error(error);
    }finally{
      loading.value = false;
    }
  }
}

watch([checkin,duration],() => {
  const checkinDate = new Date(checkin.value); 
  const newCheckout = new Date(checkinDate.getTime() + duration.value * 24 * 60 * 60 * 1000);
  checkout.value = newCheckout.toISOString().substr(0, 10);
})

watch(key,async() => {
  try{
    const response: any = await hotelStore.searchKeyword({
      q: key.value,
      checkin: checkin.value,
      checkout: checkout.value,
      room: room.value,
      adt: adt.value,
      chd: chd.value,
    })
    if(response?.status.code == 200){
      hotels.value = response.details;
    }
  }catch(error){
    console.error(error)
  }
})

</script>
<template>
  <Customloading v-if="loading" />
  <div>
    <div class="form mx-2">
      <div class="my-3">
        <div class="row mb-3">
          <div class="col-12 col-lg-8 col-md-8">
            <label for="">Hotel / Kota</label>
            <div class="dropdown input-group mb-3">
              <button
                class="form-select rounded text-start"
                type="button"
                id="dropdownHotel/Kota"
                @click="focusSearch()"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
              {{ selectedCity ? `${selectedCity.country}, ${selectedCity.name}` : selectedHotel ? `${selectedHotel.name}, ${selectedHotel.city}` : '-- Pilih Hotel / Kota --' }}
              </button>
              <ul
                class="dropdown-menu pt-0 w-100 full-width"
                aria-labelledby="dropdownHotel/Kota"
                style="width: 17rem; position: relative"
              >
                <div class="bg-white sticky-top py-1">
                  <input
                    type="text"
                    class="form-control border border-1 rounded shadow-none m-2"
                    v-model="key"
                    style="
                      max-width: calc(100% - 16px);
                      top: 0;
                    "
                    placeholder="Search..."
                    ref="cariInput"
                    autocomplete="off"
                  />
                </div>
                <div class="scrollable-menu mx-2">
                  <li v-for="city in hotels.city" @click="selectCity(city)">
                    <label>{{city.name}}</label>
                    <span class="badge bg-primary">Kota</span>
                    <div style="display: block">
                      <small class="text-default"
                        ><em>{{ city.country }}</em></small
                      >
                    </div>
                  </li>
                  <li v-for="hotel in hotels.hotel" @click="selectHotel(hotel)">
                    <label>{{ hotel.name }}</label>
                    <span class="badge bg-primary">Hotel</span>
                    <div style="display: block">
                      <small class="text-default"
                        ><em>{{ hotel.country }}, {{ hotel.city }}</em></small
                      >
                    </div>
                  </li>
                </div>
              </ul>
            </div>
          </div>
          <div class="col-12 col-lg-4 col-md-4 mb-3">
            <label for="">Jumlah Tamu & Kamar</label>
            <button 
              class="form-select rounded text-start full-width-sm" 
              type="button" 
              id="trip" 
              data-bs-toggle="dropdown" 
              aria-expanded="false"
              style="width: calc(100% - 20px); top: 0; overflow: hidden;"
            >
            {{ `${adt} Dewasa`}}<label v-if="chd > 0">, {{ `${chd} Anak` }}</label> - {{ `${room} Kamar` }}
            </button>
            <ul class="dropdown-menu p-2" aria-labelledby="trip" @pointerdown.stop @click.stop>
              <div class="mx-2 my-3">
                <div class="row mt-3">
                  <div class="col col-lg-6 col-md-6">
                    <label>Dewasa</label><br>
                    <small class="pb-3" style="font-size: 10px;">(diatas 17 tahun)</small>
                  </div>
                  <div class="col col-lg-6 col-md-6">
                    <InputNumber v-model="adt" :min="1" :max="2" />
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col col-lg-6 col-md-6">
                    <label>Anak</label><br>
                    <small class="pb-3" style="font-size: 10px;">(dibawah 17 tahun)</small>
                  </div>
                  <div class="col col-lg-6 col-md-6">
                    <InputNumber v-model="chd" :min="0" :max="2" />
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col col-lg-6 col-md-6">
                    <label class="pb-3">Jumlah Kamar</label>
                  </div>
                  <div class="col col-lg-6 col-md-6">
                    <InputNumber v-model="room" :min="1" :max="5" />
                  </div>
                </div>
                <div class="row mt-3">
                  <small class="" style="font-size: 10px;">
                    Setiap tipe kamar hanya untuk dua dewasa per kamar.<br />Tipe kamar tergantung dari ketersediaan hotel.
                  </small>
                </div>
              </div>
            </ul>
          </div>
        </div>
        
        <div class="row">
          <div class="col-12 col-lg-3 col-lg-3 mb-3">
            <label for="">Check In</label>
            <dateInput v-model="checkin" />
            <small>Check Out : <em>{{ formatDate(checkout) }}</em></small>
          </div>
          <div class="col-12 col-md-3 col-lg-3 mb-3">
            <label for="">Durasi</label>
            <select class="form-select" aria-label="Durasi" v-model="duration">
              <option value="1" selected>1 Malam</option>
              <option value="2">2 Malam</option>
              <option value="3">3 Malam</option>
              <option value="4">4 Malam</option>
              <option value="5">5 Malam</option>
              <option value="6">6 Malam</option>
              <option value="7">7 Malam</option>
              <option value="8">8 Malam</option>
              <option value="9">9 Malam</option>
              <option value="10">10 Malam</option>
            </select>
          </div>
          <div class="col-12 col-lg-3 col-md-3 mt-4">
            <!-- <NuxtLink to="/hotels/search"> -->
              <button
                type="button"
                class="btn fw-semibold text-white btn-warning"
                @click="getHotel"
                style="width: 100%;"
              >
                Cari Hotel
              </button>
            <!-- </NuxtLink> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.dropdown button:hover {
  cursor: pointer;
}

.scrollable-menu {
  max-height: 200px;
  overflow: auto;
}

.scrollable-menu li {
  display: block;
  position: relative;
  padding: 8px;
  width: 100%;
}

.scrollable-menu li .badge {
  position: absolute;
  right: 8px;
  top: 40%;
  transform: translateY(-50%);
}

.scrollable-menu li:hover {
  background-color: #f8f9fa;
}
</style>  